import algoliasearch from 'algoliasearch/lite';

const client = algoliasearch(process.env.VUE_APP_ALGOLIA_PROJECT, process.env.VUE_APP_ALGOLIA_API_KEY);
const indexes = {
    'purchaseOrders': (process.env.NODE_ENV == 'production') ? 'controlsmart_purchase_orders' : 'dev_controlsmart_purchase_orders',
    'invoices': (process.env.NODE_ENV == 'production') ? 'controlsmart_invoices' : 'dev_controlsmart_invoices',
}

export {
    client,
    indexes
}